<template>
  <div class="page-audio-list">
    <skeleton v-if="created && loading" />
    <template v-else>
      <product-filter v-if="showFilter"
                      type="audio"
                      :params="params"
                      @submit="saveParams"
      />
      <ym-loadmore v-model="loading"
                   :finished="allLoad"
                   @load="fetchData"
      >
        <list :list="list"
              empty-string="暂无课程"
              :show-empty="allLoad"
        />
      </ym-loadmore>
    </template>
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import Skeleton from '@/skeleton/ProductList';
  import ProductFilter from '@/components/ProductFilter';
  import List from '@/components/ProductList/List';
  import { getAudioList } from '@/services/audio';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageAudioList',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      Skeleton,
      ProductFilter,
      'ym-loadmore': Loadmore,
      List,
    },
    data() {
      return {
        created: false,
        start: 0,
        query: null,
        params: '',
        list: [],
        allLoad: false,
        loading: false,
        exploreType: 'rightStart',
        render: {
          pageTitle: '音频课程',
        },
      };
    },
    computed: {
      showFilter() {
        const { $route } = this;
        const { query } = $route;
        const { showFilterBar } = query;
        // 兼容不传 showFilterBar 和 showFilterBar=1的时候展示筛选栏
        return showFilterBar == null || showFilterBar === '1';
      },
    },
    methods: {
      saveParams(query) {
        this.resetData();
        const route = { name: 'AudioList', query };
        this.$router.push(route);
      },
      resetData() {
        this.list = [];
        this.start = 0;
        this.exploreType = 'rightStart';
        this.allLoad = false;
        this.loading = false;
      },
      sliceParams(params) {
        return decodeURI(params).slice(decodeURI(params).indexOf('?') + 1);
      },
      async fetchData(created = false) {
        if (this.allLoad) return;
        this.loading = true;
        this.created = created;

        const { exploreType, start, query } = this;
        const params = Object.assign({
          start,
          exploreType,
          limit: LIMIT,
        }, query);
        const data = await getAudioList(params, true);

        this.created = false;
        this.render = data.render;

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.start = data.start;
        this.exploreType = data.exploreType;
        this.list = [...this.list, ...data.list];

        this.loading = false;
      },
    },
    created() {
      this.query = this.$route.query;
      this.params = this.sliceParams(this.$route.fullPath);
      this.fetchData(true);
    },
    beforeRouteUpdate(to, from, next) {
      this.query = to.query;
      this.params = this.sliceParams(to.fullPath);
      this.fetchData(true);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-audio-list {
    max-width: @size-ignore-max-width;
    min-height: 100%;
    background: @color-white;
  }

</style>
